export default __webpack_public_path__ + "static/media/settlements-payroll.5e1f7644.svg";